import React, { ReactNode } from "react"

type CustomListItem = {
  node: React.ReactNode
}
type CreateCustomListItemsParams = Array<React.ReactNode | CustomListItem>

export const headerSection = (ele:React.ReactNode): React.ReactNode =>  {
    return (
      <li className="tos-li roman-list terms-subheading text-xl font-bold m-0">
        {ele}
      </li>
    )
}

export const createOrderSublist = (ele:React.ReactNode) => {
    return (
      <li className="tos-li-wrapper tos-remove-style">
        <ol className="sub-list ml-8 ">
          {ele}
        </ol>
      </li>
    )
}

export const createCustomListItems = (arrayOfListItems: CreateCustomListItemsParams):React.ReactNode => {
    return arrayOfListItems.map((li, idx) => {
        if(typeof li === "object" && li !== null && "node" in li) {
        return <React.Fragment key={li.node as string}>{li.node}</React.Fragment>
        }

        return (
        <li key={li as string} className="bold-list upper-alpha-list terms-paragraph indent">
            {li}
        </li>
        )
    })
}


export const createLiWrapperWithOrderList = (ele: ReactNode):ReactNode => {
    return (
        <li className="tos-remove-style">
            <ol className="w-full my-4 mx-1 remove-indent">
                {ele}
            </ol>
        </li>
    )
}

export const createLowerRomanSubOrderlist = (ele: ReactNode[]):ReactNode => {
    return (
        <ol className="w-full my-1 indent">
            {ele.map((bullet:ReactNode) => {
                    return(
                    <li key={bullet as string} className="lower-roman-list mx-5 my-1">
                        {bullet}           
                    </li>
                    )
                }
            )}
        </ol>
    )
}

export const createLowerAlphaListItem = (ele:ReactNode[] | ReactNode):ReactNode => {
    return (
        <li className="tos-remove-style">
            <ol className="w-full my-1">
                {Array.isArray(ele) ? ele?.map((bullet:ReactNode) => {
                    return (
                        <li key={bullet as string} className="lower-alpha-list ml-4 indent">
                            {bullet}
                        </li>
                    )
                }
                ): 
                    <li className="lower-alpha-list mx-5 indent">
                        {ele}
                    </li>
                }
            </ol>
        </li>
    )
}

export const createSubNumberListItem = (ele:ReactNode):ReactNode => {
    return (
        <li className= "sub-num-list num-list mx-3" >
            {ele}
        </li>
    )
}

export const createDoubleParenNumListItem = (text: ReactNode[]):ReactNode => {
    return (
        <ol className="w-full my-1 indent">
            {text.map((bullet:ReactNode, idx) => {
                return(
                    <li key={bullet as string} className="double-paren-num-list mx-4 my-1">
                        {bullet}           
                    </li>
                )} 
            )}
        </ol>
    )
}
